import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useSnackbar } from 'notistack'
import { Operacao } from "../../../Models/Cadastros/Operacao/Operacao";
import { useConfirm } from "material-ui-confirm";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
//import OperacaoCadastroPopup from "../Operacoes/Operacoes";
import DataGridBuscaComponent from "../../../Components/Forms/DataGridBuscaComponent";
import OperacaoCadastroPopup from "./OperacaoCadastroPopup";

const OperacaoPesquisaPopup = (props: any) => {
    const [openCadastroPopup, setOpenCadastroPopup] = useState(false);
    const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
    const [operacao, setOperacao] = useState<any>(new Operacao());
    const closePopupAction = () => setOpenPopupConfirm(false);
    const handleCloseCadastroPopup = () => setOpenCadastroPopup(false);
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();

    const openCadastroPopupEventCallback = () => {
        setOperacao(new Operacao());
        setOpenCadastroPopup(true);
    }

    const editarOperacao = async (id: any) => {
        let response: any = await axios.get(`operacoes/${id}`);
        setOperacao(response.data);
        setOpenCadastroPopup(true);
    };

    const solicitaExcluirOperacao = async (id: any) => {
        await confirm({ title: "Deseja realmente apagar este registro?" });
        enqueueSnackbar(`ID = ${id}`, {variant: 'success'});
    };

    const columns: any[] = [
        { dataIndex: 'descricao', title: 'Descrição', minWidth: 200, flex: 0.3, },
        { dataIndex: 'observacao', title: 'Observação', minWidth: 200, flex: 0.3, }
    ];
    
    return (
        <div>
            <BasePopup title="Operações" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={openCadastroPopupEventCallback}>
                <DataGridBuscaComponent apiBusca="buscaGridOperacoes" columns={columns} onEditAction={editarOperacao} onDeleteAction={solicitaExcluirOperacao} fieldId='id' />
            </BasePopup>

            {openCadastroPopup ? <OperacaoCadastroPopup isOpen={openCadastroPopup} onClose={handleCloseCadastroPopup} operacao={operacao} /> : ''}
        </div>
    );
}

export default OperacaoPesquisaPopup;
